import * as React from "react";
import * as url from "url";
// components
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import ShavedText from "common/components/shavedText";
import decodedURIComponentAsPlainText from "@vingle/wtf-sdk/helpers/decodedURIComponentAsPlainText";
// styles

const styles = require("./linkPreview.scss");

const TITLE_LINE_HEIGHT = 28;
const DESCRIPTION_LINE_HEIGHT = 24;

interface ILinkPreviewProps {
  linkPreview: Vingle.ILinkPreview;
}

interface IState {
  titleShaveHeight: number;
  descriptionShaveHeight: number;
}

class LinkPreview extends React.PureComponent<ILinkPreviewProps, IState> {
  public state: IState = {
    titleShaveHeight: TITLE_LINE_HEIGHT,
    descriptionShaveHeight: DESCRIPTION_LINE_HEIGHT,
  };

  private readonly title: React.RefObject<HTMLDivElement> = React.createRef();
  private readonly description: React.RefObject<
    HTMLDivElement
  > = React.createRef();

  public componentDidMount() {
    const { linkPreview } = this.props;
    if (linkPreview.title || linkPreview.description) {
      this.measureShaveHeight();
    }
  }

  public componentDidUpdate(prevProps: ILinkPreviewProps) {
    const { linkPreview: prevLinkPreview } = prevProps;
    const { linkPreview: currentLinkPreview } = this.props;
    if (
      prevLinkPreview.title !== currentLinkPreview.title ||
      prevLinkPreview.description !== currentLinkPreview.description
    ) {
      this.measureShaveHeight();
    }
  }

  public render() {
    const { linkPreview } = this.props;

    let titleElement: React.ReactNode = null;
    let descriptionElement: React.ReactNode = null;
    let urlElement: React.ReactNode = null;
    let imageElement: React.ReactNode = null;

    if (linkPreview.title) {
      titleElement = (
        <div
          ref={this.title}
          className={styles.title}
          style={{ maxHeight: this.state.titleShaveHeight }}
        >
          <ShavedText
            value={decodedURIComponentAsPlainText(linkPreview.title)}
            shaveHeight={this.state.titleShaveHeight}
          />
        </div>
      );
    } // 28px per line
    if (linkPreview.description) {
      descriptionElement = (
        <div
          ref={this.description}
          className={styles.description}
          style={{ height: this.state.descriptionShaveHeight }}
        >
          <ShavedText
            value={linkPreview.description}
            shaveHeight={this.state.descriptionShaveHeight}
          />
        </div>
      ); // 24px per line
    }
    if (linkPreview.url) {
      const host = url.parse(linkPreview.url).hostname;
      urlElement = (
        <div className={styles.url}>
          {host}
          <IconWrapper
            className={styles.linkArrowIcon}
            icon={PACKS.POST_SHOW.LINK_PREVIEW_ARROW}
          />
        </div>
      );
    }
    if (linkPreview.image) {
      imageElement = (
        <div
          className={styles.image}
          style={{ backgroundImage: `url(${linkPreview.image})` }}
        />
      );
    }

    return (
      <div>
        <div className={styles.linkPreviewContainer}>
          <a
            className={styles.linkPreviewAnchor}
            href={linkPreview.url}
            target="_blank"
          >
            <div className={styles.linkPreviewContentContainer}>
              <div className={styles.content}>
                {titleElement}
                {descriptionElement}
                {urlElement}
              </div>
              {imageElement}
            </div>
          </a>
        </div>
      </div>
    );
  }

  private readonly measureShaveHeight = () => {
    const titleContentNode = this.title.current;
    const descriptionContentNode = this.description.current;
    if (titleContentNode) {
      if (descriptionContentNode) {
        if (titleContentNode.offsetHeight > 28) {
          this.setState({
            titleShaveHeight: 2 * TITLE_LINE_HEIGHT,
            descriptionShaveHeight: 2 * DESCRIPTION_LINE_HEIGHT,
          });
        } else {
          this.setState({
            descriptionShaveHeight: 3 * DESCRIPTION_LINE_HEIGHT,
          });
        }
      } else {
        this.setState({
          titleShaveHeight: 3 * TITLE_LINE_HEIGHT,
        });
      }
    } else if (descriptionContentNode) {
      this.setState({
        descriptionShaveHeight: 4 * DESCRIPTION_LINE_HEIGHT,
      });
    }
  };
}
export default LinkPreview;
